/**
 * „de" inaintea substantivului, dupa regula romaneasca a numeralului.
 *
 * Numeralele al caror rest la 100 e intre 1 si 19 NU primesc „de" („9 coloane",
 * „115 coloane"); toate celelalte il primesc („51 de coloane", „100 de coloane").
 *
 * Exista pentru ca textul „Cele {n} de coloane" era scris de mana in rezumatul de
 * pe mobil si iesea „Cele 9 de coloane" pe rapoartele mici. S-a vazut abia la o
 * masuratoare la 360px — din citirea codului nu se observa.
 */
export function deNumeral(n: number): string {
    const rest = Math.abs(Math.trunc(n)) % 100;
    return rest >= 1 && rest <= 19 ? '' : 'de ';
}
